import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { LotePresupuestoService } from 'src/app/services/lote-presupuesto.service';
import { LotePresupuesto } from 'src/app/models/entities/lote-presupuesto';
import { PresupuestoAcumulado } from 'src/app/models/entities/presupuesto-acumulado';
import { PresupuestoAcumuladoMes } from 'src/app/models/entities/presupuesto-acumulado-mes';
import { take } from 'rxjs/operators';
interface ProgramadoEjercido {
  mes: string;
  modificado: number;
  ejercido: number;
}
interface ProgramadoEjercidoDireccion {
  mes: string;
  modificadoRural: string;
  ejercidoRural: string;
  modificadoFederal: string;
  ejercidoFederal: string;
}

@Component({
  selector: 'calendario-pef',
  templateUrl: './calendario-pef.component.html',
  styleUrls: ['./calendario-pef.component.scss']
})
export class CalendarioPefComponent implements OnInit {

  public meses: string[] = [
    "Enero",
    "Febrero",
    "Marzo",
    "Abril",
    "Mayo",
    "Junio",
    "Julio",
    "Agosto",
    "Septiembre",
    "Octubre",
    "Noviembre",
    "Diciembre"
  ];
  public programadoEjercidoDireccion: ProgramadoEjercidoDireccion[] = [];
  @Output()
  public datosCargados: EventEmitter<ProgramadoEjercidoDireccion[]> = new EventEmitter<ProgramadoEjercidoDireccion[]>();
  constructor(private lotePresupuestoService: LotePresupuestoService) { }

  async ngOnInit(): Promise<void> {
    let formatter = new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'MXN',
    });
    let mesesRurales: ProgramadoEjercido[] = await this.obtenerMesesRurales();
    let mesesFederales: ProgramadoEjercido[] = await this.obtenerMesesFederales();
    this.programadoEjercidoDireccion = this.meses.map((mes: string) => {
      let mesRural: ProgramadoEjercido = mesesRurales.find((pe: ProgramadoEjercido) => pe.mes === mes);
      let mesFederal: ProgramadoEjercido = mesesFederales.find((pe: ProgramadoEjercido) => pe.mes === mes);
      let ped: ProgramadoEjercidoDireccion = {
        mes,
        modificadoRural: mesRural ? formatter.format(mesRural.modificado).substring(3) : "",
        ejercidoRural: mesRural ? formatter.format(mesRural.ejercido).substring(3) : "",
        modificadoFederal: mesFederal ? formatter.format(mesFederal.modificado).substring(3) : "",
        ejercidoFederal: mesFederal ? formatter.format(mesFederal.ejercido).substring(3) : "",
      }
      return ped;
    });
    this.datosCargados.emit(this.programadoEjercidoDireccion);
  }

  public async obtenerMesesRurales(): Promise<ProgramadoEjercido[]> {
    let mesesRurales: ProgramadoEjercido[] = [];
    let lotePresupuesto: LotePresupuesto = await this.lotePresupuestoService.findByKeyCatDireccion('0').pipe(take(1)).toPromise();
    let presupuestoCaminosRurales: PresupuestoAcumulado = lotePresupuesto.lotePresupuestoAcumulado.presupuestosAcumulados.find((pa: PresupuestoAcumulado) => pa.keyPrograma === '3');
    let acumuladoModificados: number[] = [];
    let acumuladoTotales: number[] = [];
    acumuladoModificados.push(0);
    acumuladoTotales.push(0);
    presupuestoCaminosRurales.presupuestosAcumuladosMeses.forEach((pam: PresupuestoAcumuladoMes, i: number) => {
      let mesRurales: ProgramadoEjercido = {
        mes: this.meses[pam.mes],
        modificado: pam.modificado === 0 ? 0 : acumuladoModificados[i] + pam.modificado,
        ejercido: pam.totalEjercido === 0 ? 0 : acumuladoTotales[i] + pam.totalEjercido
      };
      acumuladoModificados.push(acumuladoModificados[i] + pam.modificado);
      acumuladoTotales.push(acumuladoTotales[i] + pam.totalEjercido);
      mesesRurales.push(mesRurales);
    });
    return mesesRurales;
  }

  public async obtenerMesesFederales(): Promise<ProgramadoEjercido[]> {
    let mesesFederales: ProgramadoEjercido[] = [];
    let lotePresupuesto: LotePresupuesto = await this.lotePresupuestoService.findByKeyCatDireccion('1').pipe(take(1)).toPromise();
    let presupuestoCaminosRurales: PresupuestoAcumulado = lotePresupuesto.lotePresupuestoAcumulado.presupuestosAcumulados.find((pa: PresupuestoAcumulado) => pa.keyPrograma === '3');
    let acumuladoModificados: number[] = [];
    let acumuladoTotales: number[] = [];
    acumuladoModificados.push(0);
    acumuladoTotales.push(0);
    presupuestoCaminosRurales.presupuestosAcumuladosMeses.forEach((pam: PresupuestoAcumuladoMes, i: number) => {
      let mesRurales: ProgramadoEjercido = {
        mes: this.meses[pam.mes],
        modificado: pam.modificado === 0 ? 0 : acumuladoModificados[i] + pam.modificado,
        ejercido: pam.totalEjercido === 0 ? 0 : acumuladoTotales[i] + pam.totalEjercido
      };
      acumuladoModificados.push(acumuladoModificados[i] + pam.modificado);
      acumuladoTotales.push(acumuladoTotales[i] + pam.totalEjercido);
      mesesFederales.push(mesRurales);
    });
    return mesesFederales;
  }

}
